//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['url', 'saveBtn', 'publishBtn'],
    components: {},
    data: function data() {
        return {
            infoProjectId: 0,
            name: '',
            pages: [],
            currentPage: {}
        };
    },
    created: function created() {
        var _this = this;

        axios.get(this.url).then(function (response) {
            var data = response.data.data;

            _this.infoProjectId = data.id;
            _this.name = data.name;
            _this.pages = data.content.pages;

            if (_this.pages.length > 0) {
                _this.showPage(_this.pages[0]);
            }
        });
    },
    mounted: function mounted() {
        var _this2 = this;

        if (this.saveBtn != null) {
            document.querySelector(this.saveBtn).addEventListener('click', function () {
                _this2.save();
            });
        }
        if (this.publishBtn != null) {
            document.querySelector(this.publishBtn).addEventListener('click', function () {
                _this2.publish();
            });
        }
    },

    methods: {
        save: function save() {
            axios.post(route('info-projects.update', this.infoProjectId), {
                data: this.pages
            }).then(function () {
                window.swal({
                    title: window.i18n.messages.success,
                    html: 'Erfolgreich gespeichert.',
                    type: 'info'
                });
            }).catch(function () {
                window.swal({
                    title: window.i18n.messages.error,
                    html: 'Fehler beim Speichern!',
                    type: 'error'
                });
            });
        },
        publish: function publish() {
            axios.post(route('info-projects.publish', this.infoProjectId)).then(function () {
                window.swal({
                    title: window.i18n.messages.success,
                    html: 'Erfolgreich veröffentlicht.',
                    type: 'info'
                });
            }).catch(function () {
                window.swal({
                    title: window.i18n.messages.error,
                    html: 'Fehler beim Veröffentlichen!',
                    type: 'error'
                });
            });
        },
        showPage: function showPage(page) {
            this.currentPage = page;
        },
        uploadImage: function uploadImage() {
            var fileUpload = this.$el.querySelector('[name=fileUpload]');
            fileUpload.click();
        },
        fileUploaded: function fileUploaded() {
            var _this3 = this;

            var fileUpload = this.$el.querySelector('[name=fileUpload]');
            if (fileUpload.files.length < 1) {
                return;
            }

            var fileReader = new FileReader();
            fileReader.addEventListener('load', function (e) {
                _this3.currentPage.url = e.currentTarget.result;
            });
            fileReader.readAsDataURL(fileUpload.files[0]);
        },
        addPage: function addPage() {
            var index = 0;
            if (this.pages.length !== 0) {
                index = this.pages.length;
            }

            var newPage = {
                title: 'Neue Seite',
                type: 'image',
                url: null,
                file_id: null,
                index: index
            };
            this.pages[index] = newPage;
            this.recalculatePageIndices();
            this.showPage(newPage);
        },
        showNearestPage: function showNearestPage(index) {
            if (!this.pages.length) {
                return;
            }

            index += 1;

            if (index >= this.pages.length) {
                this.showPage(this.pages[this.pages.length - 1]);
            } else if (index < 0) {
                this.showPage(this.pages[0]);
            }
        },
        deleteCurrentPage: function deleteCurrentPage() {
            var index = this.currentPage.index;
            this.pages.splice(index, 1);

            this.recalculatePageIndices();
            this.showNearestPage(index);
        },
        recalculatePageIndices: function recalculatePageIndices() {
            for (var i = 0; i < this.pages.length; ++i) {
                this.pages[i].index = i;
            }
        }
    },
    computed: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Editor.vue
// module id = 49
// module chunks = 0